import axiosInstance from "../interceptor/instance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}`;

export const getDashboards = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/dashboard`
  );
  
  return response.data;
};

export const getCredentials = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/superset/access-token`
  );
  return response.data;
};

export const saveDashboards = async (payload) => {
  const response = await axiosInstance.post(
    `${baseUrl}/dashboard`,
    payload
  );
  return response;
};

export const handleEmbedDashboard = async (payload) => {
  const response = await axiosInstance.post(
    `${baseUrl}/superset/guest-token`,
    payload
  );
  return response;
};